
    if (import.meta.env.PROD) {
      document.write('<meta http-equiv="Content-Security-Policy" content="default-src \'self\'; script-src \'self\' https://*.botnexus.ai; connect-src \'self\' https://*.botnexus.ai;">');
    }
  